import { Link } from "react-router-dom";
import { ImageWithDefault } from "../../../Layout/Common/imageWithDefault";
import { QuantityStripper } from "../../../Layout/Common/quantityStripper";
import { Fragment, isValidElement, useContext, useEffect, useRef, useState } from "react";
import { PriceBreakup } from "./priceBreakup";
import { isValidArray } from "../../../Layout/Common/common";
import { GlobalContext } from "../../../Context/GlobalContext";
import { LineEntryResponse } from "../../QuickOrder/quickOrdSidePopup/LineEntryResponse";

export const SearchResultContainer = ({ item, onSuccess }) => {
  const [qty, setQty] = useState();
  const [cartParams, setCartParams] = useState();
  const { CartItem } = useContext(GlobalContext);
  const [stockStatus, setStockStatus] = useState("");
  const successtoastRef = useRef();
  const productDivRef = useRef();
  useEffect(() => {
    if (item) {
      setQty({ prod_id: item.productId, qty: 0 });
      setCartParams({
        code: item.sku,
        desc: item.description,
        img: item.productImage,
      });
      setStockStatus(item?.stockStatusObj);
      console.log("status", item);
    }
  }, [item]);

  useEffect(() => {
    if (item && CartItem && CartItem.cartItem && CartItem.cartItem.length > 0) {
      var products = CartItem.cartItem;
      var filterProductId = products.find((cartItem) => String(cartItem.prod_id) == String(item.productId));
      setQty({
        prod_id: item.productId,
        qty: filterProductId?.qty ?? 0,
      });
    } else {
      setQty({ prod_id: item.productId, qty: 0 });
    }
  }, [CartItem, item]);

  return (
    <Fragment>
      {item && (
        <div ref={productDivRef} className="quickOrder-productContainer mt-3">
          <div className="quickOrder-product">
            <div className="cart-added-products quickOrderAdd">
              <div className="added-cartPro-img">
                <ImageWithDefault src={item.image} alt="Product-image" />
              </div>
              <div className="added-cartPro-content">
                <div className="added-cartPro-info">
                  <div className="added-cartPro-item">
                    <h6>
                      <Link to={item.productUrl}>{item.description}</Link>
                    </h6>
                    {stockStatus?.isShowBuy && qty && cartParams && (
                      <div className="mt-2 mb-2">
                        <QuantityStripper
                          prd={qty}
                          params={cartParams}
                          showToaster={false}
                          callbackfunction={(result) => {
                            if (result) onSuccess();
                          }}
                        />
                      </div>
                    )}
                    <div></div>
                    <div className="quickOrder-availability">
                      <p>
                        Code<span>{`: ${item.sku}`}</span>
                      </p>
                      {stockStatus?.stockStatus && (
                        <p style={{ display: "flex", flexDirection: "row" }}>
                          <span style={{ color: "inherit", fontWeight: "inherit" }}>Availability:</span>
                          <span
                            className="stock-status"
                            dangerouslySetInnerHTML={{ __html: stockStatus.stockStatus }}
                          ></span>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {isValidArray(item.priceTableList) && <PriceBreakup priceDetails={item.priceTableList} />}
          </div>
        </div>
      )}
    </Fragment>
  );
};
